import { Button, Card, Row, Col, Spinner, Container } from "reactstrap";
import "./Register.css";

import { ChangeEvent, useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import moment from "moment";
import InputStandard from "../components/Inputs/InputStandard";
import { UserTypeContext } from "../context/UserTypeContext";
import FormHelperText from "@mui/material/FormHelperText";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import { useNavigate } from "react-router-dom";

const Register = () => {
  const { createUsers, setFormValuesUsers, formValuesUsers, validateEmail } =
    useContext(UserTypeContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  const [inputKey, setInputKey] = useState(0);

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    password: "",
    postalCode: "",
  });

  const handleRegisterClick = async () => {
    setLoading(true);
    if (validateForm()) {
      await createUsers(formValuesUsers);
    }
    setLoading(false);
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors: any = { ...errors };
    const requiredFields = ["name"];

    requiredFields.forEach((field) => {
      if (!formValuesUsers[field] && formValuesUsers[field] !== 0) {
        isValid = false;
        newErrors[field] = "Campo Obrigatório";
      } else {
        newErrors[field] = "";
      }
    });

    if (newErrors["email"]) {
      isValid = false;
    }

    setErrors(newErrors);

    return isValid;
  };

  const handleBlurAddressCep = async (valueAtt: any, name: string) => {
    const newErrors: any = { ...errors };
    setInputKey((prevKey) => prevKey + 1);

    setFormValuesUsers((prevValues: { address: any }) => ({
      ...prevValues,
      address: {
        ...prevValues.address,
        [name]: valueAtt,
      },
    }));

    const cleanCep = valueAtt.replace(/[^\d]/g, "");

    if (cleanCep.length !== 8) {
      newErrors["postalCode"] = "CEP Inválido";
      setErrors(newErrors);
      setInputKey((prevKey) => prevKey + 1);
      return;
    } else {
      newErrors["postalCode"] = "";
      setErrors(newErrors);
    }

    try {
      const response = await fetch(
        `https://viacep.com.br/ws/${cleanCep}/json/`
      );

      if (!response.ok) {
        newErrors["postalCode"] = "Erro ao buscar CEP!";
        setErrors(newErrors);
      } else {
        newErrors["postalCode"] = "";
        setErrors(newErrors);
      }

      const data = await response.json();

      if (data.erro) {
        newErrors["postalCode"] = "CEP não encontrado!";
        setErrors(newErrors);
        setInputKey((prevKey) => prevKey + 1);
        return;
      }

      const updatedAddress = {
        ...formValuesUsers.address,
        postalCode: valueAtt,
        street: data.logradouro || "",
        district: data.bairro || "",
        city: data.localidade || "",
        state: data.uf || "",
        country: "Brasil",
      };

      setFormValuesUsers((prevState: any) => ({
        ...prevState,
        address: updatedAddress,
      }));

      setInputKey((prevKey) => prevKey + 1);
    } catch (error) {
      console.error("Erro ao buscar o CEP:", error);
    }
  };

  const handleBlur = (valueAtt: any, name: string) => {
    setFormValuesUsers({
      ...formValuesUsers,
      [name]: valueAtt,
    });
  };

  const handleBlurEmail = async (valueAtt: any, name: string) => {
    const newErrors: any = { ...errors };

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(valueAtt)) {
      newErrors["email"] = "O e-mail é inválido.";
      setErrors(newErrors);
      setInputKey((prevKey) => prevKey + 1);
      return;
    } else {
      newErrors["email"] = "";
      setErrors(newErrors);
    }

    setDisable(true);
    const result = await validateEmail(valueAtt);
    setDisable(false);

    if (result) {
      newErrors["email"] = "E-mail já utilizado!";
      setErrors(newErrors);
    } else {
      const newErrors: any = { ...errors };
      newErrors["email"] = "";
      setErrors(newErrors);
    }

    setFormValuesUsers({
      ...formValuesUsers,
      [name]: valueAtt,
    });
  };

  const handleBlurAddress = (valueAtt: any, name: string) => {
    setFormValuesUsers((prevValues: { address: any }) => ({
      ...prevValues,
      address: {
        ...prevValues.address,
        [name]: valueAtt,
      },
    }));
  };

  return (
    <Container
      fluid
      style={{
        minHeight: "100vh",
        position: "relative",
        backgroundColor: "#fff",
      }}
    >
      {/* Logo (absoluto, canto esquerdo) */}
      <div style={{ position: "absolute", top: "30px", left: "10px" }}>
        <img
          className="register-logo"
          alt="Logo"
          src={require("../assets/img/brand/Simbolo_Negativa_sf.png")}
        />
      </div>

      {/* Botão Login (absoluto, canto direito) */}
      <div style={{ position: "absolute", top: "30px", right: "10px" }}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            window.location.href = "/auth/login";
          }}
          className="register-login-btn"
          type="button"
          disabled={loading}
        >
          <Person2OutlinedIcon />
          <span>Login</span>
        </Button>
      </div>

      {/* Título da página */}
      <Row className="mt-5 justify-content-center">
        <Col xs="12" className="text-center">
          <h2 className="register-title" style={{ marginTop: "51px" }}>
            Criar nova conta
          </h2>
          <p className="register-subtitle">Preencha os campos para criar sua conta</p>
        </Col>
      </Row>

      {/* Formulário em duas colunas, usando quase toda a largura */}
      <Row className="px-5 g-4">
        {/* Coluna 1: Dados Pessoais */}
        <Col
          md="6"
          className="p-4"
          style={{ display: "flex", flexDirection: "column", gap: "10px" }}
        >
          <h5 className="register-section-title">Dados Pessoais</h5>

          <div
            className="d-flex align-items-center mb-2"
            style={{ gap: "10px" }}
          >
            <InputStandard
              disabled={disable}
              name="email"
              handleChange={handleBlurEmail}
              value={formValuesUsers?.email}
              label="Email"
            />
            {disable && <Spinner size="sm" />}
          </div>
          <FormHelperText error>{errors.email}</FormHelperText>

          <InputStandard
            name="name"
            handleChange={handleBlur}
            value={formValuesUsers?.name}
            label="Nome"
          />
          <FormHelperText error>{errors.name}</FormHelperText>

          <InputStandard
            type="password"
            name="password"
            handleChange={handleBlur}
            value={formValuesUsers?.password}
            label="Senha"
          />
          <small className="register-hint">
            Mínimo de 8 caracteres, letras maiúsculas, minúsculas e um símbolo
            como #%!
          </small>
          <FormHelperText error>{errors.password}</FormHelperText>

          <InputStandard
            name="nationalRegisterCode"
            handleChange={handleBlur}
            value={formValuesUsers?.nationalRegisterCode}
            label="CPF/CNPJ"
          />

          <InputStandard
            name="phone"
            handleChange={handleBlur}
            mask="(99) 99999-9999"
            value={formValuesUsers?.phone}
            label="Telefone"
          />
        </Col>

        {/* Coluna 2: Endereço */}
        <Col
          md="6"
          className="p-4"
          style={{ display: "flex", flexDirection: "column", gap: "10px" }}
        >
          <h5 className="register-section-title">Endereço</h5>

          <InputStandard
            name="postalCode"
            handleChange={handleBlurAddressCep}
            value={formValuesUsers?.address?.postalCode}
            label="CEP"
            mask="99999-999"
          />
          <FormHelperText error>{errors.postalCode}</FormHelperText>

          <InputStandard
            name="street"
            handleChange={handleBlurAddress}
            value={formValuesUsers?.address?.street}
            label="Rua"
          />
          <FormHelperText />

          <InputStandard
            name="addtionalData"
            handleChange={handleBlurAddress}
            value={formValuesUsers?.address?.addtionalData}
            label="Complemento"
          />
          <FormHelperText />

          <InputStandard
            name="district"
            handleChange={handleBlurAddress}
            value={formValuesUsers?.address?.district}
            label="Bairro/Distrito"
          />
          <FormHelperText />

          <InputStandard
            name="city"
            handleChange={handleBlurAddress}
            value={formValuesUsers?.address?.city}
            label="Cidade"
          />
          <FormHelperText />

          <InputStandard
            name="state"
            handleChange={handleBlurAddress}
            value={formValuesUsers?.address?.state}
            label="Estado"
          />
          <FormHelperText />

          <InputStandard
            name="country"
            handleChange={handleBlurAddress}
            value={formValuesUsers?.address?.country}
            label="País"
          />
          <FormHelperText />
        </Col>
      </Row>

      {/* Botão "Criar minha conta" */}
      <Row className="mt-3 justify-content-center">
        <Col xs="12" className="text-center">
          <Button
            onClick={handleRegisterClick}
            className="register-submit-btn"
            type="button"
            disabled={loading}
          >
            {loading && <Spinner size="sm" className="me-2" />}
            Criar minha conta
          </Button>
        </Col>
      </Row>

      {/* Link "Já tem conta? Faça login" */}
      <Row className="mt-2 justify-content-center">
        <Col xs="12" className="text-center">
          <small className="register-subtitle">
            Já tem uma conta?{" "}
            <a
              href="#pablo"
              className="register-login-link"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "/auth/login";
              }}
            >
              Faça login
            </a>
          </small>
        </Col>
      </Row>
    </Container>
  );
};

export default Register;
